import { Drawer, Button } from '@mui/material';

interface UploadTwoBtnDialogProps {
  open: boolean;
  onClose?: (event: React.SyntheticEvent | {}, reason: string) => void;
  leftBtnTitle?: string;
  rightBtnTitle?: string;
  onLeftClick?: () => void;
  onRightClick?: () => void;
}

export default function UploadTwoBtnDialog({
  open,
  onClose = () => {},
  leftBtnTitle = '',
  rightBtnTitle = '',
  onLeftClick = () => {},
  onRightClick = () => {},
}: UploadTwoBtnDialogProps) {
  return (
    <Drawer
      open={open}
      anchor="bottom"
      onClose={(event: any, reason: any) => {
        if (reason === 'backdropClick') return;
        if (onClose) onClose(event, reason);
      }}
      PaperProps={{
        sx: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <div className="w-full p-5 min-h-[200px] gap-3 flex flex-col items-center justify-end bg-[] overflow-hidden">
        <Button
          variant="grayPainted"
          className="w-full"
          onClick={onLeftClick}
          sx={{ borderRadius: '10px', borderBottom: '2px solid #E9E9E9' }}
        >
          {leftBtnTitle}
        </Button>
        <Button
          variant="grayPainted"
          className="w-full"
          onClick={onRightClick}
          sx={{ borderRadius: '10px' }}
        >
          {rightBtnTitle}
        </Button>
      </div>
    </Drawer>
  );
}
